import { Config } from '@/config/environment';

export interface AuthProviderConfig {
  authUrl: string;
  tokenUrl: string;
  userInfoUrl: string;
  logoutUrl: string;
  scopes: string[];
  redirectUri: string;
}

export const getAuthConfig = (): AuthProviderConfig => {
  const provider = Config.auth.provider;
  const baseUrl = Config.auth.url;
  const redirectUri = `${window.location.origin}/oauth-redirect`;

  const configs: Record<string, AuthProviderConfig> = {
    okta: {
      authUrl: `${baseUrl}/oauth2/v1/authorize`,
      tokenUrl: `${baseUrl}/oauth2/v1/token`,
      userInfoUrl: `${baseUrl}/oauth2/v1/userinfo`,
      logoutUrl: `${baseUrl}/oauth2/v1/logout`,
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      redirectUri,
    },
    fusionauth: {
      authUrl: `${baseUrl}/oauth2/authorize`,
      tokenUrl: `${baseUrl}/oauth2/token`,
      userInfoUrl: `${baseUrl}/oauth2/userinfo`,
      logoutUrl: `${baseUrl}/oauth2/logout`,
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      redirectUri,
    },
  };

  const config = configs[provider];
  if (!config) {
    throw new Error(`Unknown auth provider: ${provider}`);
  }

  return config;
};